'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthBitHeader = require('@narvar/nth-bit-header');
var Paragraph = require('@narvar/nth-bit-paragraph');
var PickupLocationIcon = require('./PickupLocationIcon.js');
var PickupLocationNotFound_module = require('./PickupLocationNotFound.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);

const PickupLocationNotFound = ({
  featureName
}) => {
  const {
    locationNotFoundHeader,
    locationNotFoundDescription
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: PickupLocationNotFound_module["default"].root
  }, /*#__PURE__*/React__default["default"].createElement(PickupLocationIcon["default"], null), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "p",
    featureName: featureName,
    containerCustomStyle: {
      marginTop: '1rem'
    }
  }, locationNotFoundHeader), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, locationNotFoundDescription));
};
var PickupLocationNotFound$1 = nthHookTranslations.withTranslationsProvider(PickupLocationNotFound, {
  translationKeys: ['locationNotFoundHeader', 'locationNotFoundDescription']
});

exports["default"] = PickupLocationNotFound$1;
